<template>
  <div class="father">
    <div class="canvas-top">
      <wtystyle keys="wtycanvas" element="canvas" ref="wtyStyleRef" @styleReturn="styleReturn"></wtystyle>
    </div>
    <div class="canvas-main">
      <div v-if="false" class="left-icon">
        <div v-for="(item, index) in iconList" :key="index" class="left-icon-item">
          <el-tooltip class="item" effect="dark" :content="item.label" placement="right">
            <i :class="item.class" @click="addElement(item.id)">{{
              item.text
            }}</i>
          </el-tooltip>
        </div>
      </div>
      <div :style="`height:${eleAttribute.height}px;width:${eleAttribute.width}px`">
        <el-scrollbar wrapStyle="" :style="`height:${eleAttribute.height}px;width:${eleAttribute.width}px`
          ">
          <div class="canvas-body">
            <!-- {{ `height:${eleAttribute.height}px;width:${eleAttribute.width}px` }} style="border:1px solid black;"-->
            <canvas id="c" :width="eleAttribute.width" :height="eleAttribute.height">
            </canvas>
          </div>
        </el-scrollbar>
      </div>
      <div class="right-mode" :style="`height:${eleAttribute.height}px;width:100%;max-width:300px`">
        <div class="right-setting-main">
          <!-- <div class="right-setting-main-title" style="border-top: 1px solid #dcdfe6;">
              <el-dropdown @command="dropdownSet">
                <span
                  class="el-dropdown-link right-setting-main-select"
                >
                  {{ selectE.mode }}
                </span>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in selectE.selectList"
                    :key="item"
                    :command="item"
                    >{{ item }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
          <div style="display:flex;justify-content: between;align-items: center;height: 30px;">
            <el-popover placement="bottom" width="300" trigger="click">
              <div style="min-height:200px">
                <el-select @change="modeChange" @visible-change="chooseMode" v-model="onlinefilemodename"
                  style="width:100%; border:none !important;" placeholder="选择线上模板">
                  <el-option style="border:none !important;" v-for="item in onlinePrintModeFileList" :key="item"
                    :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <span slot="reference" class="el-dropdown-link right-setting-main-select"
                style="color:#409EFF;font-weight: 700;">
                公共模板导入
              </span>
            </el-popover>

            <!-- <div @click="exportTemplate" style="width:200px;height: auto;color:#00ac17;font-weight: 700;cursor: pointer;">
              导出模板
            </div> -->
          </div>
          <!-- <wty-template ref="wtyTemplateRef"></wty-template> -->
          <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:155px">
            <div></div>
            <div class="right-setting-main-checkbox">
              <!-- <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%"> -->
              <el-checkbox-group v-model="insertList" @change="checkedChange">
                <el-checkbox border v-for="(item, index) in labelList" :label="item.label" :key="index"
                  style="margin:0 10px 0 0;"></el-checkbox>
              </el-checkbox-group>
              <el-radio-group @input="imgChange" v-model="imgInsert">
                <el-radio label="uparrow" border>上箭头</el-radio>
                <el-radio label="downarrow" border>下箭头</el-radio>
              </el-radio-group>
              <!-- TODO: 自定义字符串模板 -->
              <div class="custom-main">
                <div class="custom-main-item" v-for="(item, index) in custom_list" :key="index">
                  <el-input size="small" @keyup.enter.native="
                    addElement(
                      'itext',
                      { text: custom_list[index] },
                      `text${text_count}`
                    )
                    " v-model="custom_list[index]">
                    <template slot="prepend">字符串</template>
                    <template slot="append"><span class="icon-add">+</span></template>
                  </el-input>
                  <!-- <el-input v-model="custom_list[i]"></el-input>
                  <div >+</div> -->
                </div>
              </div>
              <!-- <el-checkbox-group v-model="imgInsert" @change="imgChange">
                <el-checkbox
                  border
                  v-for="(item, index) in imgList"
                  :label="item.label"
                  :key="index"
                  style="margin:0 10px 0 0;"
                ></el-checkbox>
              </el-checkbox-group> -->
              <!-- </el-scrollbar> -->
            </div>
          </el-scrollbar>
        </div>

        <div class="all-template ">
          <div class="all-template-header right-setting-main-title">
            所有模板
          </div>
          <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:calc(100% - 35px)">
            <div class="all-template-main">
              <div class="all-template-main-i" v-for="(item, index) in print_list" :key="index">
                <div @click="getTemplate(item.template_no)" class="all-template-main-item" :class="item.template_no == temp_info.template_no
                  ? 'all-template-main-item-checked'
                  : ''
                  ">
                  {{ `${item.template_no} : ${item.template_name}` }}
                </div>
                <div v-if="item.template_no == temp_info.template_no" @click="deleteTemplate(item.template_no)"
                  class="all-template-main-item-delete">
                  删除模板
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>

        <div class="dyh-footer">
          <el-button @click="flushCanvas(190, 400)" style="width:50%">重置模板</el-button>
          <el-button type="primary" @click="exportToJSON" style="width:50%;margin:0px">保存模板</el-button>
        </div>
      </div>
    </div>
    <dyhCreatetemp @printRegister="printRegister" @modifyRegister="getTemplate" ref="dyhCreatetempRef"></dyhCreatetemp>
  </div>
</template>
<script>
/* eslint-disable */
import { mapMutations } from "vuex";
import { exportFile } from "@/js/docx.js";
// import SketchRule from "vue-sketch-ruler";
import wtystyle from "@/components/wty-style.vue";
// import wtyTemplate from "./wty-template.vue";
import dyhCreatetemp from "./dyh-createtemp.vue";
import { pxtoMM, imgToBase64 } from "@/js/public.js";
import { getprintList, printQuery, printDelete } from "@/api/merchant.js";
import { baseUrl } from "@/api/common.js";
import { fabric } from "fabric";
import { getFile, getFileDetail } from "@/api/index.js";
// import { deleteTabRepeat } from '../js/public';

const downImg = require("@/assets/pic/down.png");
const upImg = require("@/assets/pic/up.png");
export default {
  components: { wtystyle, dyhCreatetemp },
  data() {
    return {
      text_count: 0, //字符串的数量
      custom_list: [""], //自定义字符串列表
      onlinePrintModeFileList: [], //线上模板
      onlinefilemodename: "", //线上模板名
      print_list: [], //模板
      eleAttribute: {
        width: "988",
        height: "528"
      },
      names: "",

      iconList: [
        {
          id: "itext",
          class: "",
          text: "T",
          label: "插入文本",
          clicks: "ttt"
        },
        {
          id: "img",
          class: "el-icon-picture-outline",
          text: "",
          label: "插入图片",
          clicks: "ttt"
        },
        {
          id: "round",
          class: "",
          text: "◯",
          label: "插入一个圆",
          clicks: "ttt"
        },
        {
          class: "triangle",
          text: "◁",
          label: "插入一个三角形",
          clicks: "ttt"
        },
        {
          class: "rectangle",
          text: "▭",
          label: "插入一个矩形",
          clicks: "ttt"
        },
        {
          id: "line",
          class: "",
          text: "线",
          label: "插入一个线",
          clicks: "ttt"
        }
      ],
      canvasEle: {},
      // element: "canvas",
      canvas: {},
      selectE: {
        mode: "专用标价牌",
        selectList: ["专用标价牌", "显示器"],
        unit: "px"
      },
      selecteData: {},
      insertList: [],
      labelList: [
        {
          label: "商品名称",
          value: "item_name"
        },
        {
          label: "商品条码",
          value: "barcode"
        },
        {
          label: "商品售价",
          value: "sale_price"
        },
        {
          label: "商品货号",
          value: "item_no"
        },
        {
          label: "商品规格",
          value: "item_size"
        },
        {
          label: "商品产地",
          value: "product_area"
        },
        {
          label: "商品单位",
          value: "unit"
        },
        {
          label: "商品保质期",
          value: "life_day"
        },
        {
          label: "商品会员价",
          value: "vip_price"
        },
        {
          label: "商品品牌",
          value: "brand_name"
        },
        {
          label: "商品等级",
          value: "grade"
        },
        {
          label: "店铺名称",
          value: "mch_name"
        },
        {
          label: "供应商号",
          value: "sup_no"
        },
        {
          label: "供应商名称",
          value: "sup_name"
        }
      ],
      imgInsert: "",
      temp_info: {},
      modify: false,
      canvasJson: "",
      barcodeBarcode: {} //barcode条码的条码
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        this.eleAttribute.height = newinner.innerHeight - 190;
        this.eleAttribute.width = Math.round(
          this.eleAttribute.height * (710 / 392)
        );
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
    unit() {
      return this.$store.state.canvas.unit;
    }
  },
  mounted() {
    var that = this;
    this.canvas = new fabric.Canvas("c"); // 使用 fabric 绑定画布，将画布的id传入 fabric.Canvas 方法里
    const mainrect = new fabric.Rect({
      top: 0,
      left: 0,
      width: 400,
      height: 190,
      fill: "rgba(255,255,255,.1)",
      label: "方块",
      hasRotatingPoint: false, //当属性为false时，Object的控制器旋转点将不会显示和被选中。默认为true。
      borderScaleFactor: 0,
      hasBorders: false,
      evented: false,
      stroke: "black",
      hasControls: false,
      lockUniScaling: false,
      selectable: false,
      transparentCorners: true,
      statefullCache: true,
      type: "rect"
    });
    /* const image = fabric.Image.fromURL(
      "../assets/pic/yvzhou.png", // 图片路径
      {
        left: 100, //设置图片位置
        top: 20, //设置图片位置
        angle: 30, //设置图形顺时针旋转角度
        opacity: 0.5, //设置透明度
        scaleX: 0.5, //设置缩放比例
        scaleY: 0.5 //设置缩放比例
      }
    ); */

    mainrect.sendToBack();
    this.$set(this.canvasEle, "mainrect", mainrect);
    this.canvas.add(this.canvasEle.mainrect);
    this.canvas.on("mouse:down", options => {
      if (options.target != null) {
        this.selecteData = options.target;
        that.names = options.target.type;
      } else {
        this.selecteData = this.canvasEle.mainrect;
        that.names = "canvas";
      }
      //画布内容选中事件
      this.$refs.wtyStyleRef.styleChange(that.names, this.selecteData);
    });
    document.onkeydown = function (res) {
      if (that.names == "canvas" || that.names == "activeSelection") {
        return;
      }
      if (res.code == "Delete") {
        that.styleReturn({ names: that.names, key: "remove", res: "" });
        return;
      }
    };

    this.getprintList(); //获取打印模板
  },
  methods: {
    ...mapMutations("canvas", ["CHANGECOMPUTE"]),

    /**
     * 文件模板导入
     */
    async chooseMode(e) {
      this.onlinePrintModeFileList = await getFile();
      console.log("list------------k", this.onlinePrintModeFileList);
    },
    async modeChange(e) {
      this.jsonToImport((await getFileDetail(e)).data);
    },
    //导入json模板
    inputJsonToImport() {
      // FileSaver.saveAs("https://httpbin.org/image", "image.jpg");
      try {
        this.jsonToImport(JSON.parse(this.canvasJson), "file");
        this.temp_info = JSON.parse(this.canvasJson);
      } catch (err) {
        this.warnMessage("模板导入失败!");
      }
    },
    //dyh模板注册组件的返回
    printRegister(res) {
      if (res) {
        this.getprintList();
      }
    },
    /**
     * 获取所有模板接口
     */
    getprintList() {
      getprintList().then(res => {
        if (this.testR(res)) {
          this.print_list = res.data.resp_data;
        }
      });
    },
    deleteTemplate(template_no) {
      this.$confirm("此操作将永久删除该模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          printDelete(template_no).then(res => {
            if (this.testR(res)) {
              this.$message({
                type: "success",
                message: "模板删除成功！"
              });
              this.getprintList();
              this.flushCanvas(190, 400);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /**
     * 获取模板详情
     * @param {string} template_no
     */
    getTemplate(template_no) {
      //获取模板
      printQuery(template_no).then(res => {
        /* return; */
        if (this.testR(res) && res.data && res.data.resp_data) {
          this.jsonToImport(res.data.resp_data, "web"); //导入模板方法
          this.temp_info = res.data.resp_data;
          //条码特殊的属性
          if (this.temp_info.design.content.barcode) {
            this.barcodeBarcode = this.temp_info.design.content.barcode.barcode;
          }
          this.modify = true;
          // this.imgInsert = "";
        }
      });
    },
    /* showModal() {
      this.$refs.wtyTemplateRef.showDialog();
    }, */
    checkedChange(e) {
      var oldList = [];
      var add = [];
      var del = [];
      //TODO: 这里循环的是canvasEle
      for (let key in this.canvasEle) {
        for (let i = 0; i < this.labelList.length; i++) {
          if (key == this.labelList[i].value) {
            oldList.push(this.labelList[i].label);
          }
        }
      }
      //全是新增的时候
      if (oldList.length == 0) {
        for (let j = 0; j < e.length; j++) {
          for (let i = 0; i < this.labelList.length; i++) {
            if (this.labelList[i].label == e[j]) {
              add.push(this.labelList[i]);
            }
          }
        }
        for (let item in add) {
          this.addElement(
            "textbox",
            { text: add[item].label },
            add[item].value
          );
        }
      } else if (oldList.length > 0) {
        //找老数组里面有新数组里面没有的 找出取消勾选的元素

        for (let i = 0; i < oldList.length; i++) {
          if (!e.includes(oldList[i])) {
            del.push(oldList[i]);
          }
        }
        // console.log("找老数组里面有新数组里面没有的 找出取消勾选的元素", del);
        //找新组里面有 老数组里面没有的 找出新勾选的元素
        for (let i = 0; i < e.length; i++) {
          if (!oldList.includes(e[i])) {
            add.push(e[i]);
          }
        }
        // console.log("找新组里面有 老数组里面没有的 找出新勾选的元素", add);

        /* del = e.filter(item => {
          !oldList.includes(item);
        }); */

        if (add.length > 0) {
          let list = [];
          for (let j = 0; j < add.length; j++) {
            for (let i = 0; i < this.labelList.length; i++) {
              if (this.labelList[i].label == add[j]) {
                list.push(this.labelList[i]);
              }
            }
          }
          for (let item in list) {
            this.addElement(
              "textbox",
              { text: list[item].label },
              list[item].value
            );
          }
        }
        if (del.length > 0) {
          for (let j = 0; j < del.length; j++) {
            for (let i = 0; i < this.labelList.length; i++) {
              if (this.labelList[i].label == del[j]) {
                this.selecteData = this.canvasEle[this.labelList[i].value];
                this.styleReturn({ names: "textbox", key: "remove", res: "" });
                // delete this.canvasEle[this.labelList[i].value];
              }
            }
          }
        }
      }
    },
    //选中元素值修改的返回
    styleReturn({ names, key, res }) {
      if (key == "remove") {
        var value = "";
        //删除选中元素
        this.canvas.remove(this.selecteData);

        //文本元素 和 文本域元素
        for (let i = 0; i < this.labelList.length; i++) {
          if (
            this.selecteData.text &&
            this.labelList[i].label ==
            this.selecteData.text.replace(/[^\u4e00-\u9fa5]/gi, "")
          ) {
            value = this.labelList[i].value;
          }
        }
        //如果是图片 则value 等于单选框的值
        if (names == "image") {
          value = this.imgInsert;
        }
        delete this.canvasEle[value];
        if (names == "image" && this.imgInsert && res == !"in") {
          this.imgInsert = "";
        }
        let m = [];
        //如果是文本元素则重新赋值选择框
        if (names == "textbox" || names == "i-text") {
          //重新设置复选框的值
          for (let i = 0; i < this.insertList.length; i++) {
            if (this.insertList[i] != this.selecteData.text) {
              m.push(this.insertList[i]);
            }
          }
          this.insertList = m;
        }
      }
      //不是按的删除属性的时候
      this.selecteData[key] = res;
      this.$nextTick(() => {
        this.canvas.renderAll();
      });
    },
    asyncLoadImg(imgURL, value) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(imgURL, img => {
          /* img.scaleX = 0.25; //设置缩放比例
          img.scaleY = 0.25; */
          img.top = value.top ? value.top : 0;
          img.left = value.left ? value.left : 0;
          // 加载出错提示，否则会造成渲染出错
          if (img._originalElement === null) {
            reject("图片加载出错啦~~~");
          } else {
            resolve(img);
          }
        });

        // 4.2.0版本有错误处理
        // fabric.Image.fromURL(imgURL, (img,isError) => {})
      });
    },

    imgChange(e) {
      // addElement
      switch (e) {
        case "uparrow":
          // this.styleReturn({names:'image',key:'remove'});
          for (let key in this.canvasEle) {
            if (key == "uparrow" || key == "downarrow") {
              this.styleReturn({ names: "image", key: "remove", res: "in" });
              delete this.canvasEle["downarrow"];
              delete this.canvasEle["uparrow"];
            } else if (key == e) {
              return;
            }
          }

          setTimeout(async () => {
            this.addElement(
              "img",
              { top: 0, left: 0 },
              e,
              await imgToBase64(upImg)
            );
          }, 100);
          break;
        case "downarrow":
          for (let key in this.canvasEle) {
            if (key == "uparrow" || key == "downarrow") {
              this.styleReturn({ names: "image", key: "remove", res: "in" });
              delete this.canvasEle["uparrow"];
              delete this.canvasEle["downarrow"];
            } else if (key == e) {
              return;
            }
          }
          setTimeout(async () => {
            this.addElement(
              "img",
              { top: 0, left: 0 },
              e,
              await imgToBase64(downImg)
            );
          }, 100);
          break;
      }
    },
    /**
     * @param {"textbox"|"itext"|"img"} key textbox-定义好的文本块 itext-可编辑文本 img-上下箭头
     * @param {Object} value 传递过来的初始值
     * @param {string} names 字段名  in_price barcode
     */
    async addElement(key, value = {}, names = "", url = "") {
      switch (key) {
        case "textbox":
          if (value) {
            var data = {};
            data = {
              top: 60, // 文本到画布顶部的距离
              left: 100, // 文本到画布左侧的距离
              textAlign: "left",
              width: 100,
              height: 80,
              fontSize: 20,
              fontStyle: "normal",
              cornerSize: 12,
              transparentCorners: false,
              cornerColor: "rgba(0,0,0,.3)",
              fontFamily: "黑体",
              editable: false, //是否允许编辑
              selectionBackgroundColor: "#deeeff99"
            };
            this.canvasEle[names] = new fabric.Textbox(value.text, data);
            this.canvas
              .add(this.canvasEle[names])
              .setActiveObject(this.canvasEle[names]);
            // text.fontWeight = 200;
            // text.fontStyle = "oblique";
            // this.canvasEle[names]["setControlVisible"]("ml", false);
            this.canvasEle[names]["setControlVisible"]("mb", false);
            // this.canvasEle[names]["setControlVisible"]("mr", false);
            this.canvasEle[names]["setControlVisible"]("mt", false);
            this.canvasEle[names]["setControlVisible"]("mtr", false);
            this.canvasEle[names]["setControlVisible"]("tl", false);
            this.canvasEle[names]["setControlVisible"]("tr", false);
            this.canvasEle[names]["setControlVisible"]("bl", false);
            this.canvasEle[names]["setControlVisible"]("br", false);
            this.canvas.renderAll();
            //删除矩形
            // this.canvas.remove(this.canvasEle.rect);
          }
          break;
        case "itext":
          this.canvasEle[names] = new fabric.IText(value.text, {
            top: 60, // 文本到画布顶部的距离
            left: 100, // 文本到画布左侧的距离
            width: 200,
            height: 90,
            caching: true,
            fontSize: 20,
            fontFamily: "幼圆",
            /* lockScalingX:true,
            lockScalingY:true, */
            caching: false,
            centeredScaling: false,
            cornerSize: 12,
            transparentCorners: false,
            editable: false,
            cornerColor: "rgba(0,0,0,.3)"
          });
          // itext.set('fill',"#fff");
          // this.canvas.add(itext).setActiveObject(itext);
          this.canvas
            .add(this.canvasEle[names])
            .setActiveObject(this.canvasEle[names]);
          // itext.fontStyle = "oblique";
          // itext.underline = true;

          // itext["setControlVisible"]("ml", false);
          this.canvasEle[names]["setControlVisible"]("mb", false);
          // this.canvasEle[names]["setControlVisible"]("mr", false);
          this.canvasEle[names]["setControlVisible"]("mt", false);
          this.canvasEle[names]["setControlVisible"]("mtr", false);
          this.canvasEle[names]["setControlVisible"]("tl", false);
          this.canvasEle[names]["setControlVisible"]("tr", false);
          this.canvasEle[names]["setControlVisible"]("bl", false);
          this.canvasEle[names]["setControlVisible"]("br", false);

          //删除矩形
          // this.canvas.remove(this.canvasEle.rect);
          break;
        case "img":
          this.canvasEle[names] = await this.asyncLoadImg(url, value);
          this.canvas.add(this.canvasEle[names]);
          this.canvasEle[names]["setControlVisible"]("mb", false);
          this.canvasEle[names]["setControlVisible"]("mr", false);
          this.canvasEle[names]["setControlVisible"]("ml", false);
          this.canvasEle[names]["setControlVisible"]("mt", false);
          this.canvasEle[names]["setControlVisible"]("mtr", false);
          this.canvasEle[names]["setControlVisible"]("tl", false);
          this.canvasEle[names]["setControlVisible"]("tr", false);
          this.canvasEle[names]["setControlVisible"]("bl", false);
          this.canvasEle[names]["setControlVisible"]("br", false);
          this.canvas.renderAll();
          this.selecteData = this.canvasEle[names];
          break;
        case "round":
          this.exportToJSON();
          break;
      }
    },
    /**
     * 保存提交模板
     */
    exportToJSON() {
      var imgtext = "";
      if (this.imgInsert !== "" || this.imgInsert.length > 0) {
        if (this.imgInsert == "uparrow") {
          imgtext = "上箭头";
        } else if (this.imgInsert == "downarrow") {
          imgtext = "下箭头";
        }
      }
      const result = this.canvas.toJSON();
      var json = [];
      var text_count = 0;
      for (let key in result.objects) {
        var m = {};
        if (
          result.objects[key].type == "textbox" ||
          result.objects[key].type == "i-text"
        ) {
          m = {
            left: result.objects[key].left,
            top: result.objects[key].top,
            width: result.objects[key].width,
            height: result.objects[key].height,
            font_family: result.objects[key].fontFamily,
            fontWeight: result.objects[key].fontWeight,
            font_size: result.objects[key].fontSize,
            underline: result.objects[key].underline,
            linethrough: result.objects[key].linethrough,
            textAlign: result.objects[key].textAlign,
            fontStyle: 0,
            other1: result.objects[key].type,
            other2: result.objects[key].version,
            other3: result.objects[key].text
          };
          if (result.objects[key].type == "textbox") {
            if (result.objects[key].text) {
              for (let i = 0; i < this.labelList.length; i++) {
                if (
                  result.objects[key].text.replace(/[^\u4e00-\u9fa5]/gi, "") ==
                  this.labelList[i].label
                ) {
                  m.other4 = this.labelList[i].value;
                }
              }
            }
          } else if (result.objects[key].type == "i-text") {
            m.other4 = `text${text_count}`;
            text_count++;
          }
        } else if (
          result.objects[key].type == "rect" ||
          result.objects[key].type == "image"
        ) {
          m = {
            left: result.objects[key].left,
            top: result.objects[key].top,
            width: result.objects[key].width,
            height: result.objects[key].height,
            other1: result.objects[key].type,
            other2: result.objects[key].version,
            other3: result.objects[key].type == "image" ? imgtext : ""
          };
          if (result.objects[key].type == "image" && this.imgInsert) {
            m.other4 = this.imgInsert;
            m.other5 = result.objects[key].src;
            m.src = result.objects[key].src;
          }
        }

        //  &&imgtext?imgtext:

        json.push(m);
      }
      //TODO: --------------- 空的
      // return;
      this.$refs.dyhCreatetempRef.showDialog(
        json,
        this.modify,
        this.temp_info.template_no && this.temp_info.template_name
          ? this.temp_info
          : false,
        this.barcodeBarcode ? this.barcodeBarcode : false
      );
    },
    flushCanvas(h, w) {
      let importobj = [];
      let b = {
        label: "方块",
        hasRotatingPoint: false, //当属性为false时，Object的控制器旋转点将不会显示和被选中。默认为true。
        borderScaleFactor: 0,
        hasBorders: false,
        evented: true,
        stroke: "black",
        hasControls: false,
        lockUniScaling: false,
        selectable: false,
        transparentCorners: true,
        statefullCache: true,
        originX: "left",
        originY: "top",
        stroke: "black",
        fill: "rgba(255,255,255,.1)",
        skewX: 0,
        skewY: 0,
        rx: 0,
        ry: 0,
        left: 0,
        top: 0,
        width: Number(w),
        height: Number(h),
        type: "rect",
        version: "5.3.0"
      };
      //TODO 9-11修改
      /* if (this.unit=='mm') {
        b.width = b.width * 5;
        b.height = b.height * 5;
      } */

      let c = { ...b };
      importobj.push(c);
      var data = {
        version: "5.3.0",
        objects: [c]
      };
      this.canvas.loadFromJSON(JSON.stringify(data));
      this.canvas.renderAll();
      this.insertList = [];
      this.temp_info = {};
      this.canvasEle = {};
    },
    //TODO: 导入模板
    /**
     *
     * @param {object} jsons 模板详情
     * @param {'file'|'web'} key   导入源
     */
    jsonToImport(jsons, key) {
      //获取到的模板单位
      if (jsons.design.unit) {
        this.CHANGECOMPUTE(jsons.design.unit);
      } else {
        //如果没有就是老模板 都是按照毫米
        this.CHANGECOMPUTE("mm");
      }
      let json = jsons.design.content;
      if (this.unit == "mm") {
        jsons.design.page_height = jsons.design.page_height * 5;
        jsons.design.page_width = jsons.design.page_width * 5;
      } else if (this.unit == "px") {
        jsons.design.page_height = jsons.design.page_height / 20;
        jsons.design.page_width = jsons.design.page_width / 20;
      }

      this.flushCanvas(jsons.design.page_height, jsons.design.page_width);

      for (let key in json) {
        if (this.unit == "mm") {
          json[key].left = json[key].left * 5;
          json[key].top = json[key].top * 5;
          json[key].width = json[key].width * 5;
          json[key].height = json[key].height * 5;
        } else if (this.unit == "px") {
          json[key].left = json[key].left / 20;
          json[key].top = json[key].top / 20;
          json[key].width = json[key].width / 20;
          json[key].height = json[key].height / 20;
        }
        if (json[key].other1 == "textbox" || json[key].other1 == "i-text") {
          let b = {
            cornerSize: 12,
            cornerColor: "rgba(0,0,0,.3)",
            transparentCorners: false,
            left: Number(json[key].left),
            top: Number(json[key].top),
            width: Number(json[key].width),
            height: Number(json[key].height),
            fontFamily: json[key].font_family ? json[key].font_family : "黑体",
            fontWeight: json[key].fontWeight,
            fontSize: json[key].font_size,
            underline: json[key].underline,
            linethrough: json[key].linethrough,
            textAlign: json[key].textAlign,
            editable: false, //是否允许编辑
            selectionBackgroundColor: "#deeeff99"
          };

          // importobj.push(b);
          //选中的字段信息
          this.insertList.push(json[key].other3);
          if (json[key].other1 == "textbox") {
            this.canvasEle[json[key].other4] = new fabric.Textbox(
              json[key].other3,
              b
            );
          } else {
            this.canvasEle[json[key].other4] = new fabric.IText(
              json[key].other3,
              b
            );
          }

          this.canvas
            .add(this.canvasEle[json[key].other4])
            .setActiveObject(this.canvasEle[json[key].other4]);
          this.canvasEle[json[key].other4]["setControlVisible"]("mb", false);
          this.canvasEle[json[key].other4]["setControlVisible"]("mt", false);
          this.canvasEle[json[key].other4]["setControlVisible"]("mtr", false);
          this.canvasEle[json[key].other4]["setControlVisible"]("tl", false);
          this.canvasEle[json[key].other4]["setControlVisible"]("tr", false);
          this.canvasEle[json[key].other4]["setControlVisible"]("bl", false);
          this.canvasEle[json[key].other4]["setControlVisible"]("br", false);
          this.canvas.renderAll();
        }
        //TODO: 9-11 改成正常的px

        if (json[key].other1 == "image") {
          this.imgInsert = json[key].other4;
          this.addElement(
            "img",
            {
              top: json[key].top,
              left: json[key].left
            },
            this.imgInsert,
            json[key].src ? json[key].src : json[key].other5
          );
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.custom-main {
  width: 100%;
  height: auto;
  padding: 10px;

  .custom-main-item {
    .icon-add {
      display: flex;
      width: 20px;
      height: 20px;
      border-radius: 10px;
      justify-content: center;
      align-items: center;
      font-size: 20px;
    }
  }
}

.dyh-footer {
  display: flex;
}

.all-template {
  width: 100%;
  height: calc(100% - 225px);

  // background-color: rgb(255, 138, 138);
  .all-template-header {
    width: 100%;
    text-align: center;
    color: #409eff;
    font-weight: 700;
  }

  .all-template-main {
    .all-template-main-i {
      display: flex;
      align-items: center;

      .all-template-main-item {
        width: 100%;
        text-align: center;
        color: #409eff;
        font-weight: 700;
        cursor: pointer;
        padding: 7px 0;
        background-color: rgba(220, 220, 220, 0.25);
        border-radius: 5px;
        margin: 5px;
      }

      .all-template-main-item-checked {
        width: calc(100% - 70px);
        color: #fff;
        background-color: #409eff;
      }

      .all-template-main-item-delete {
        color: rgb(208, 0, 0);
        font-weight: 700;
        font-size: 14px;
        width: 70px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

#c {
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  width: 80%;
  height: 60%;
  padding: 10px;
}

.father {
  height: calc(100vh - 210px);

  display: block;
  padding: 5px;

  // border: 1px solid #ccc;
  .canvas-top {
    height: 50px;
    width: 100%;
    // background-color: rgb(146, 22, 22);
  }

  .canvas-main {
    display: flex;
    justify-content: left;

    // width:;
    .canvas-body {
      min-width: 988px;
      min-height: 528px !important;
      // min-height: 300px;
      // background-color: rgb(247, 79, 79);
    }

    .left-icon {
      display: flex;
      justify-content: top;
      align-items: center;
      flex-direction: column;
      width: 50px !important;
      min-width: 50px;
      height: 100%;
      // background-color: rgb(255, 234, 234);
      padding: 10px 5px;
      cursor: pointer;

      i {
        font-style: normal;
      }

      .left-icon-item {
        height: 40px;
      }
    }
  }
}

.right-mode {
  border: 1px solid #dcdfe6;
  // border-left: none;
  // min-width: 300px;
  width: 100%;
  height: 100%;
  min-width: 250px;

  // background-color: rgb(255, 233, 253);
  .right-setting-main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    // right-setting-main-select
    &-select {
      cursor: pointer;
      color: #409eff;
      font-weight: 700;
    }

    &-title {
      width: 100%;
      height: 30px;
      // background-color: #F9F9F9;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #409eff;
      border-bottom: 1px solid #dcdfe6;
    }

    &-checkbox {
      height: auto;
      // box-shadow: inset 0 -10px 10px rgb(255, 255, 255);
    }
  }

  .right-other {
    width: 300px;
  }
}

/deep/.el-form {
  width: 100%;
  display: flex;
  padding: 2% 3% 2% 5%;
}

/deep/.el-form-item {
  width: 48%;
}

/deep/.el-input {
  width: 100%;
}

/deep/.el-input-group__prepend {
  padding: 5px;
}

/deep/.el-input-group__append {
  padding: 5px;
}

/deep/ .el-checkbox {
  min-width: 45%;
  margin: 10px 0 0 10px !important;
}

/deep/.el-radio-group {
  width: 100%;
}

/deep/ .el-radio {
  min-width: 45%;
  margin: 10px 0 0 10px !important;
}

/deep/.el-textarea__inner {
  min-height: 300px !important;
}

/deep/.dyh-canvas-img {
  width: 40px;
  height: 40px;
}
</style>
